import { Labelled } from '../../commons/model/common';
import { Moment } from 'moment';

export const REPAIR_COST_FORM_NAME = 'repairCostForm';

export type RebillingType = 'CLIENT' | 'DETENTEUR' | 'OTHERS';

export const RebillingTypeLabels: Record<RebillingType, string> = {
  CLIENT: 'Client',
  DETENTEUR: 'Détenteur',
  OTHERS: 'Autres',
};

export type InvoiceStatus = 'IN_PROGRESS' | 'PROCESSED' | 'PAID';

export const InvoiceStatusLabels: Record<InvoiceStatus, string> = {
  IN_PROGRESS: 'En cours',
  PROCESSED: 'Traitée',
  PAID: 'Soldée',
};

export type Rebillable = 'YES' | 'NO' | 'PENDING';

export const RebillableLabelButtons: Record<Rebillable, Labelled> = {
  YES: { label: 'Oui' },
  NO: { label: 'Non' },
  PENDING: { label: 'En attente' },
};

export type RepairCostType = 'QUOTE' | 'ORDER' | 'INVOICE' | 'REBILLING';

export type CostDocumentView = {
  number: string;
  date: string;
  cost: number;
  fileName: string | null;
};

export type InvoiceDocumentView = CostDocumentView & {
  status: InvoiceStatus;
};

export type RebillingView = {
  type: RebillingType;
  precision: string | null;
  number: string;
  date: string;
};

export type RepairCost = {
  id: string;
  quote: CostDocumentView | null;
  order: CostDocumentView | null;
  invoice: InvoiceDocumentView | null;
  rebillable: Rebillable;
  rebilling: RebillingView | null;
  comment: string | null;
};

export type CostDocumentFormValues = {
  number: string | null;
  date: Moment | null;
  cost: string | null; // string because handled by a number input
  fileName: string | null;
};

export type InvoiceDocumentFormValues = CostDocumentFormValues & {
  status: InvoiceStatus | null;
};

export type RebillingFormValues = {
  type: RebillingType | null;
  precision: string | null;
  number: string | null;
  date: Moment | null;
};

export type RepairCostFormValues = {
  repairCostId: string | null;
  quote: CostDocumentFormValues | null;
  order: CostDocumentFormValues | null;
  invoice: InvoiceDocumentFormValues | null;
  rebillable: Rebillable | null;
  rebilling: RebillingFormValues | null;
  comment: string | null;
};
